import React, { Component, PropTypes } from 'react';
import './styles';

/**
 * Class to display the different values in the summary on their own Row
 */
class SummaryRow extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    total: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    classNames: PropTypes.string,
    hideRow: PropTypes.bool
  };
  static defaultProps = {
    classNames: '',
    hideRow: false
  };
  render() {
    const { classNames, label, total, hideRow } = this.props;
    return (
      <div className="summary-row summary-font" aria-hidden={hideRow}>
        <p>
          <span className={`summary-row-label ${classNames}`}>{label}</span>
          <span className={`total-amount right ${classNames}`}>{total}</span>
        </p>
      </div>
    )
  }
}

export default SummaryRow;



/** WEBPACK FOOTER **
 ** ./src/pages/TrimView/BestOfferList/BestOfferCard/components/OfferSummary/SummaryRow/index.js
 **/